module.exports = __webpack_public_path__ + "static/media/app04_jpn.7904510c.png";